export enum RegistrationType {
    CORPORATE,
    PRIVATE,
    AUTHORISED,
    AUTHORISED_KYC
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/entity/registration-type.ts